import React from "react";

const StorySection = () => {

    return (
        <div className="flex justify-center w-full">
            <div className="w-full max-w-7xl px-4 pt-6 sm:px-6">
                <p className=" text-gray-700 text-justify leading-relaxed sm:leading-loose mb-8">
                    Si une grande diversité de types de cartes et de représentations iconographiques pourra être mobilisée,
                    la qualité graphique des visuels et la rigueur scientifique des textes qui les accompagnent feront
                    l'objet d'une attention particulière. Pour ce faire, la revue est dotée, d'une part, d'un comité
                    scientifique doublé d'un comité éditorial et, d'autre part, chaque article est évalué par au moins deux
                    relecteurs.
                    <br className="my-4"/>
                    <br className="my-4"/>
                    Par ailleurs, les sources associées à chaque production iconographiques pourront être mises à disposition
                    (si leur licence le permet) via l'infrastructure de données géographiques qui sera, à terme, associée à
                    la revue. Madatlas - Cartes, images et données géographiques de Madagascar, de l'Océan Indien et
                    des Afriques s'inscrit ainsi pleinement dans une dynamique de science ouverte en proposant en libre-accès
                    des articles et en mettant à disposition les données qui y sont associées.
                </p>
                <h2 className="text-3xl sm:text-4xl font-semibold text-greenprimary flex items-center mb-4">
                    <span className="w-10 sm:w-16 h-1.5 sm:h-2.5 mt-2 sm:mt-3 bg-greenprimary mr-2"></span>
                    Historique
                </h2>
                <p className=" text-justify leading-relaxed sm:leading-loose mb-8">
                    La revue Madatlas - Cartes, images et données géographiques de Madagascar, de l'Océan Indien et
                    des Afriques a été initié dans le cadre du projet de recherche MadAtlas. Ce projet, porté par l'Université
                    de Fianarantsoa, l'Université Gustave Eiffel, l'Université Bordeaux Montaigne et l'IRD, vise à favoriser
                    le développement d'une filière universitaire dans le domaine innovant de la cartographie numérique à
                    Madagascar.
                    MadAtlas fait partie des lauréats de l'appel à projets « Partenariats avec l'Enseignement Supérieur
                    Africain », lancé par l'Agence Nationale de la Recherche (ANR-France) et financé par l'Agence Française
                    de Développement (AFD), dans le cadre de la stratégie « Bienvenue en France » portée par le Ministère
                    français de l'Europe et des Affaires Étrangères, le Ministère français de l'Enseignement Supérieur de la
                    Recherche et de l'Innovation et Campus France.
                    <br className="my-4"/>
                    La création de cette revue scientifique fait partie des livrables de ce projet de recherche. Elle a pour
                    vocation d'être pérennisée au-delà de la durée du projet pour devenir, à terme, une référence éditoriale
                    sur cette région du Monde.
                </p>
            </div>
        </div>
    );
};

export default StorySection;